/* eslint-disable no-restricted-globals */
import React from 'react';
import _isNil from 'lodash/isNil';

/*
 * Displays the facilitators used for this group in all sessions
 *
 * A row per facilitator in alpha order
 */
export default settings => {
    let devTag = settings.tag;

    return ({ value, row }) => {
        // verify that the path exists before trying to map it
        if (!row['childRoles.metricspawn.assignmentProgressList']) {
            return null;
        }

        let progressList = row['childRoles.metricspawn.assignmentProgressList'];

        let facilitatorNames = [
            ...new Set(
                progressList
                    .map(response => response.devTagsLists[devTag])
                    .reduce((names, name) => {
                        if (_isNil(name)) {
                            return names;
                        }

                        return names.concat(Array.isArray(name) ? name : [name]);
                    }, [])
                    .filter(name => typeof name === 'string' || typeof name === 'number')
                    .map(name => String(name).trim())
                    .filter(Boolean)
            ),
        ].sort((left, right) => left.localeCompare(right));

        return (
            <div>
                {facilitatorNames.map(name => {
                    if (!_isNil(name)) {
                        return <div key={name}>{name}</div>;
                    }

                    return '';
                })}
            </div>
        );
    };
};
